import Contact from "@/components/sections/Contact";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <Contact />
    </div>
  );
}
